import { render, staticRenderFns } from "./LeaderBoardRowSkeleton.vue?vue&type=template&id=1b7c92b0&scoped=true&"
import script from "./LeaderBoardRowSkeleton.vue?vue&type=script&lang=js&"
export * from "./LeaderBoardRowSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./LeaderBoardRowSkeleton.vue?vue&type=style&index=0&id=1b7c92b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7c92b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VRow,VSkeletonLoader})
